import React from 'react'
import { useDropzone } from 'react-dropzone'
import {
  Box,
  Flex,
  HStack,
  IconButton,
  Input,
  Progress,
  Spacer,
  Text,
} from '@chakra-ui/react'
import { FaFileExcel } from 'react-icons/fa'
import { CgClose } from 'react-icons/cg'
import { observer } from 'mobx-react'
import rootStore from '../../../store/RootStore'

const DropzoneUploader = observer(() => {
  const {
    dropzoneStore: {
      file,
      setFile,
      uploading,
      progress,
      uploadError,
      setUploadError,
    },
    wizardStore: { setError },
  } = rootStore
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: {
      'image/*': ['.xlsx'],
    },
    multiple: false,
    onDrop: acceptedFiles => {
      setFile(acceptedFiles[0])
    },
  })

  const handleDelete = e => {
    e.stopPropagation()
    setFile(null)
    setUploadError(null)
    setError(null)
  }

  return (
    <>
      {file && file.name && (
        <HStack
          className="selected-file"
          alignItems="center">
          <FaFileExcel className="file-icon" />
          <Text>{file.name}</Text>
          <IconButton
            className="delete-button"
            onClick={handleDelete}
            aria-label="delete-file"
            size={'sm'}
            variant="ghost"
            icon={<CgClose />}
          />
        </HStack>
      )}
      {!file && (
        <Flex
          display={'flex'}
          className="dropzone-container"
          w="100%"
          border={file ? '1px dashed' : '1px solid'}
          borderColor={
            uploadError ? 'brand.red' : file ? 'brand.green' : 'brand.gray'
          }
          h="60px"
          borderRadius="4px"
          padding="16px"
          alignItems="center"
          transition="background-color 0.2s ease-in-out"
          cursor={isDragActive ? 'grabbing' : 'pointer'}
          backgroundColor={isDragActive ? 'brand.lightBlue' : 'white'}
          {...getRootProps()}>
          <Input {...getInputProps()} />
          <Text fontSize="14px">
            Drag and drop an Excel file here, or click to select a file
          </Text>
          <Spacer />
          {uploadError && <Box>{uploadError}</Box>}
        </Flex>
      )}
      {progress > 0 && uploading && (
        <Progress
          colorScheme="brand.green"
          size="sm"
          value={progress}
        />
      )}
    </>
  )
})

export default DropzoneUploader
